/**
 * Inertia scroll (ref: studioloutsis.com) via Lenis
 * (assets/lenis.min.js, MIT — darkroom.engineering). The wheel is
 * intercepted and the real scroll position eases toward the target
 * each frame, which reads as weight/momentum. Native scroll events
 * still fire, so sticky positioning, IntersectionObserver reveals,
 * and the project-hero parallax all keep working — they just inherit
 * the smoothing.
 *
 * Skipped for reduced-motion visitors, and inside the theme editor
 * (where hijacked scrolling fights the preview UI). Touch scrolling
 * stays native (Lenis default) — phones already have physical inertia.
 * Other scripts reach the instance via window.__lenis (the mobile
 * menu stops it while its overlay is open; the hero click uses its
 * scrollTo).
 */
const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)');

if (
  typeof Lenis === 'function' &&
  !prefersReduced.matches &&
  !(window.Shopify && window.Shopify.designMode)
) {
  const lenis = new Lenis({
    lerp: 0.06, // lower = more glide/weight (0.09 felt too direct)
    anchors: true,
  });
  window.__lenis = lenis;
  const raf = (time) => {
    lenis.raf(time);
    requestAnimationFrame(raf);
  };
  requestAnimationFrame(raf);
}
